export default __webpack_public_path__ + "static/media/purchaseIcon.e5993703.svg";